// extracted by mini-css-extract-plugin
export default {"theme":"dark_theme__mykpC"};